export default __webpack_public_path__ + "static/media/Line 518.cd3a421f.svg";